import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.span`
	font: ${helpers.fonts.body.large};
	color: ${helpers.color.text};
	margin-bottom: ${helpers.spacing.xSmall};
`
